import React, { useEffect } from "react";
import RecipeApp from "./RecipeApp.mp4";
import MarksheetGen from "./marksheetGenerator.mp4";
import WeatherApp from "./WeatherApp.mp4";
import GrocerryShop from "./GroceryShop.mp4"
import "./Projects.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

const projectData = [
  {
    id: 1,
    title: "Recipe App",
    video: RecipeApp,
    codeLink: "https://github.com/amresh1kumar/RecipeApp",
  },
  {
    id: 2,
    title: "Marksheet Generator",
    video: MarksheetGen,
    codeLink: "https://github.com/amresh1kumar/MarksheetGenerator",
  },
  {
    id: 3,
    title: "Weather App",
    video: WeatherApp,
    codeLink: "https://github.com/amresh1kumar/Weather-App",
  },
  {
    id: 4,
    title: "Grocerry Shop Management System",
    video: GrocerryShop,
    codeLink: "https://github.com/amresh1kumar/",
  },
];

const Projects = () => {



  useEffect(() => {

    document.title =
      "Projects | Amresh Kumar";

    const metaDescription =
      document.querySelector(
        'meta[name="description"]'
      );

    if (metaDescription) {

      metaDescription.setAttribute(
        "content",
        "Explore projects built by Amresh Kumar using React.js, Django, Node.js, CRM systems, ERP applications and chatbot integrations."
      );

    }

  }, []);
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,        // Optional: animate when scrolling up too
      easing: 'ease-in-out'
    });
  });

  return (
    <div className="main">
      <div className='video-show' >
        {projectData.map((project) => (
          <div className="project-card" key={project.id}  >
            <iframe className="iframe"
              data-aos="zoom-in-up"
              data-aos-duration="1000"
              src={project.video}
              title={project.title}
              loading="lazy"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>

            <div className="label1" data-aos="fade-up"
              data-aos-duration="1000">
              <label >{project.title}</label>
            </div>
            <div className="linkBtn">
              <a href={project.codeLink} target="_blank" rel="noreferrer">
                <button data-aos="fade-up"
                  data-aos-duration="1000">Code</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;